import { useCallback } from 'react';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconMessageOff } from '@tabler/icons-react';

import useEnsisMutation from '../../hooks/useEnsisMutation';

interface Props {
  organizationSlug: string
  proposalUid?: string
  disabled?: boolean
}

const ClearChatButton: React.FC<Props> = ({
  organizationSlug,
  proposalUid,
  disabled = false
}: Props) => {
  const createConversationMutation = useEnsisMutation('/app/conversations', {
    requestType: 'post',
    showSuccessMessage: false,
    queryKeysToInvalidate: ['/app/conversations']
  });
  const deleteConversationMutation = useEnsisMutation('/app/conversations', {
    requestType: 'delete',
    showSuccessMessage: false,
    queryKeysToInvalidate: ['/app/conversations']
  });

  const handleClearMessages = useCallback(async () => {
    await deleteConversationMutation.mutateAsync({
      organization_slug: organizationSlug,
      proposal_uid: proposalUid
    });
    createConversationMutation.mutate({
      organization_slug: organizationSlug,
      proposal_uid: proposalUid
    });
  }, [
    deleteConversationMutation.mutateAsync,
    createConversationMutation.mutate,
    organizationSlug,
    proposalUid
  ]);

  const buttonDisabled = disabled ||
    createConversationMutation.isPending ||
    deleteConversationMutation.isPending;

  return (
    <Tooltip
      label='Clear chat'
      events={{ hover: true, focus: false, touch: false }}
      position='top-end'
    >
      <ActionIcon
        disabled={buttonDisabled}
        variant='subtle'
        onClick={() => { void handleClearMessages(); }}
      >
        <IconMessageOff color="#343A40" />
      </ActionIcon>
    </Tooltip>
  );
};

export default ClearChatButton;
